export function dateTimeToLocal(date?: string | number) {
  if (!date) return '';

  const dateToTime = (d: Date) =>
    d.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    });

  const userOffset = new Date().getTimezoneOffset() * 60 * 1000;
  const localDate = new Date(date);
  const utcDate = new Date(localDate.getTime() + userOffset);

  console.log(`${dateToTime(utcDate)} (${dateToTime(localDate)} Your Time)`);

  return dateToTime(localDate);
}

export function dateTimeToLocalDate(date?: string | number) {
  if (!date) return '';

  const dateToTime = (d: Date) =>
    d.toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });

  const localDate = new Date(date);

  return dateToTime(localDate);
}

export function dateTimeToLocalTime(date?: string | number) {
  if (!date) return '';

  const dateToTime = (d: Date) =>
    d.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    });

  const localDate = new Date(date);

  return dateToTime(localDate);
}
